// @flow
export const MOUNT_POINT = 'callings';

export const SET_CALLEE = 'SET_CALLEE';
export const SET_ENTITY = 'SET_ENTITY';
export const SET_REGISTERED = 'SET_REGISTERED';
export const INITIATE_CALL = 'INITIATE_CALL';
export const SET_RINGING = 'SET_RINGING';
export const STOP_CALL = 'STOP_CALL';
export const START_CALL = 'START_CALL';
export const SET_MUTED = 'SET_MUTED';
export const SET_HELD = 'SET_HELD';
export const SET_OPERATORS = 'SET_OPERATORS';
export const UPDATE_OPERATOR_PRESENCE = 'UPDATE_OPERATOR_PRESENCE';
export const SET_CALLINGS_STATE = 'SET_CALLINGS_STATE';
export const SET_CALLING_ENTITY = 'SET_CALLING_ENTITY';
export const SEND_DTMF_REQUEST = 'SEND_DTMF_REQUEST';
export const SEND_DTMF_SUCCESS = 'SEND_DTMF_SUCCESS';
export const TRANSFER = 'TRANSFER';
export const SET_SESSION_ESTABLISHED = 'SET_SESSION_ESTABLISHED';
export const SET_START_TIME = 'SET_START_TIME';
export const CLEAR_COOLDOWN_STATE = 'CLEAR_COOLDOWN_STATE';

export const WS_DISPATCH_ACTION = 'WS_UPDATE_CALLINGS_STATE';

// The actions defined here are imported in ./middlewares.js and are intercepted by the middleware
// so that a websocket message with the action type and the action payload can be sent from the current tab
// which will update the state of the rest of the tabs
// Any new constant which defines an action type which should update the state of the other tabs, should be added here
export const workingTabPBXActionTypes = {
    SET_CALLEE,
    SET_ENTITY,
    SET_REGISTERED,
    INITIATE_CALL,
    SET_RINGING,
    STOP_CALL,
    START_CALL,
    SET_MUTED,
    SET_HELD,
    SET_OPERATORS,
    UPDATE_OPERATOR_PRESENCE,
    SET_CALLING_ENTITY,
    SEND_DTMF_REQUEST,
    SEND_DTMF_SUCCESS,
    TRANSFER,
    SET_SESSION_ESTABLISHED,
    SET_START_TIME,
    CLEAR_COOLDOWN_STATE,
};
